import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { getErrorHandler } from '@office-start/error-handler';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchFeatureSettings } from '@office-start/feature-settings-service';
import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { OfficeWorkload } from '@office-start/officehome-types';
import { logError } from '@office-start/telemetry-service';
import { httpGet } from '@office-start/xhr-service';
import { createRequestConfig } from './createRequestConfig';
import { getInstrumentation } from './instrumentResponse';
// Constants
var sectionParam = 'section=';
var section = 'OfficeComHome';
var forceNewSchema = 'forceNewSchema=true';
var locParam = 'rs=';
var officeFeedPath = 'PeoplePredictionsB2/MicrosoftFeed';
var teamsTasksQSP = 'experiment=OfficeComHomeWithTeamsTasks';
var teamsTasksQSP_Control = 'experiment=OfficeComHomeWithTeamsTasks_Control';
var stackedUpcomingMeetingsQSP = 'experiment=OfficeComHomeWithStackedMeetings';
var stackedUpcomingMeetingsQSP_Control = 'experiment=OfficeComHomeWithStackedMeetings_Control';
var stackedTasksQSP = 'experiment=OfficeComHomeWithStackedTasks';
var stackedTasksQSP_Control = 'experiment=OfficeComHomeWithStackedTasks_Control';
var fetchRequestIndex = 0;
// eslint-disable-next-line max-params
function getFullUrl(options, isSuggestedTasksFromTeamsEnabled, isStackedUpcomingMeetingsEnabled, isStackedTasksEnabled, threeSRDLFeedExperimentValue) {
    var substrateApi = options.substrateApi, inMockMode = options.inMockMode, officeApiRoot = options.officeApiRoot, officeMarket = options.officeMarket;
    var baseUrl = (inMockMode ? officeApiRoot : substrateApi) + "/".concat(officeFeedPath);
    var url = "".concat(baseUrl, "?").concat(sectionParam).concat(section, "&").concat(locParam).concat(officeMarket, "&").concat(forceNewSchema);
    url += isSuggestedTasksFromTeamsEnabled
        ? "&".concat(teamsTasksQSP)
        : "&".concat(teamsTasksQSP_Control);
    url += isStackedUpcomingMeetingsEnabled
        ? "&".concat(stackedUpcomingMeetingsQSP)
        : "&".concat(stackedUpcomingMeetingsQSP_Control);
    url += isStackedTasksEnabled
        ? "&".concat(stackedTasksQSP)
        : "&".concat(stackedTasksQSP_Control);
    if (!!threeSRDLFeedExperimentValue) {
        url += "&experiment=".concat(threeSRDLFeedExperimentValue);
    }
    return url;
}
function getXhrOptions(options, requestId) {
    var inMockMode = options.inMockMode;
    var populateRequestEvent = getInstrumentation(fetchRequestIndex++, requestId);
    var mockParam;
    if (inMockMode) {
        mockParam = 'mockrecommended';
    }
    return { populateRequestEvent: populateRequestEvent, mockParam: mockParam };
}
export function fetchFeedApiData(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function () {
        var officeComponentContext, featureGates, featureSettings, suggestedTasksFromTeamsEnabled, stackedUpcomingMeetingsEnabled, stackedTasksEnabled, threeSRDLFeedExperimentValue, requestId, objectId, tenantId, aadClientId, application, requestConfig, url, params;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    officeComponentContext = _j.sent();
                    return [4 /*yield*/, fetchFeatureGates()];
                case 2:
                    featureGates = _j.sent();
                    return [4 /*yield*/, fetchFeatureSettings()];
                case 3:
                    featureSettings = _j.sent();
                    suggestedTasksFromTeamsEnabled = ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.suggestedTasksFromTeamsGates) === null || _b === void 0 ? void 0 : _b.suggestedTasksFromTeamsEnabled) || false;
                    stackedUpcomingMeetingsEnabled = ((_d = (_c = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _c === void 0 ? void 0 : _c.stackedUpcomingMeetingsGates) === null || _d === void 0 ? void 0 : _d.stackedUpcomingMeetingsEnabled) || false;
                    stackedTasksEnabled = ((_f = (_e = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _e === void 0 ? void 0 : _e.stackedTasksGates) === null || _f === void 0 ? void 0 : _f.stackedTasksEnabled) || false;
                    threeSRDLFeedExperimentValue = ((_h = (_g = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _g === void 0 ? void 0 : _g.threeSRDLFeedExperiment) === null || _h === void 0 ? void 0 : _h.value) || '';
                    requestId = createGuid();
                    objectId = options.objectId, tenantId = options.tenantId, aadClientId = options.aadClientId;
                    application = officeComponentContext.workload === OfficeWorkload.Hwa
                        ? 'OfficeComApp'
                        : 'OfficeComHome';
                    requestConfig = createRequestConfig(requestId, objectId, tenantId, aadClientId, application, false);
                    url = getFullUrl(options, suggestedTasksFromTeamsEnabled, stackedUpcomingMeetingsEnabled, stackedTasksEnabled, threeSRDLFeedExperimentValue);
                    params = getXhrOptions(options, requestId);
                    return [2 /*return*/, httpGet(KnownInstrumentationEvents.OfficeFeedRequest, "OfficeFeedRequest" /* KnownRequestInstrumentationEvents.OfficeFeedRequest */, url, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeApiRoot, options.correlationId, 'Substrate', params)
                            .then(function (response) {
                            var _a;
                            if (!response.data) {
                                logError({
                                    eventName: 'Office_Feed_Service_Error',
                                    message: 'No data returned in office feed recommended call',
                                });
                                return {
                                    headers: (_a = response === null || response === void 0 ? void 0 : response.headers) !== null && _a !== void 0 ? _a : {},
                                    data: undefined,
                                };
                            }
                            return {
                                data: response.data,
                                headers: response.headers,
                            };
                        })
                            .catch(function (error) {
                            getErrorHandler().handleError(error, "FUfu0" /* ErrorId.FUfu0 */);
                            throw error;
                        })];
            }
        });
    });
}
//# sourceMappingURL=fetchFeedApiData.js.map